var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"spinner",style:({ height: _vm.size + 'px', width: _vm.size + 'px', 'border-width': _vm.borderWidth + 'px', 'border-color': _vm.color })})
}
var staticRenderFns = []

export { render, staticRenderFns }